<template>
	<div class="header">
		<div class="header_inner">
			<div class="header_logo">
				<img src="/img/logo.png" alt="" />
			</div>

			<div class="header_menu">
				<!-- <div class="alert" @click="infoCheck">
					<i class="fa-solid fa-bell fa-fw fa-lg" />
					<div class="alert_caution"></div>
				</div> -->

				<div class="header_item ml-12" @click="logoutModal">
					<i class="fa-solid fa-power-off fa-fw fa-lg mr-2" />ログアウト
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import { onMounted } from "vue";
// store
import { usePartsStore } from "@/stores/PartsStore";

/* ---------------------------------------------------------------------------
emit
---------------------------------------------------------------------------- */
const emit = defineEmits(["infoCheck", "logoutModal"]);
/* ---------------------------------------------------------------------------
store
---------------------------------------------------------------------------- */
const partsStore = usePartsStore();
/* ---------------------------------------------------------------------------
	props
---------------------------------------------------------------------------- */
const props = defineProps({
	currentPath: String,
	sideMenuShow: Boolean
});
/* ---------------------------------------------------------------------------
お知らせ
---------------------------------------------------------------------------- */
function infoCheck() {
	emit("infoCheck");
}
/* ---------------------------------------------------------------------------
ログアウト
---------------------------------------------------------------------------- */
function logoutModal() {
	emit("logoutModal");
}

/* ---------------------------------------------------------------------------
onMounted
---------------------------------------------------------------------------- */
onMounted(() => {
	partsStore.headerSlideMenuShow = false;
});
</script>

<style scoped lang="scss">
@use "/resources/css/_adjust.scss" as *;

.header {
	width: 100%;
	height: 70px;
	position: fixed;
	z-index: 100;
	border-bottom: 1px solid #f5f5f5;
	@include backdropFilter(8px);
	@include glassmorphismColor($bg-white2, 0.5);
}
.header_inner {
	padding: 14px 20px 15px;
	display: flex;
	align-items: center;
	margin: 0 auto;
	justify-content: space-between;
}
.header_logo {
	width: 120px;
}
.header_menu {
	display: flex;
}
.header_item {
	font-weight: normal;
	font-size: 1.4rem;
	cursor: pointer;
	@include trans(0.3);
	&:hover {
		color: $color-blue2;
		@include trans(0.3);
	}
}
.alert {
	cursor: pointer;
	font-size: 1.6rem;
	position: relative;
	@include trans(0.3);
	& i {
		color: $color-gray3;
		@include trans(0.3);
	}
	&:hover {
		i {
			color: $color-blue2;
			@include trans(0.3);
		}
	}
}
.alert_caution {
	top: -6px;
	right: -1px;
	width: 9px;
	height: 9px;
	border-radius: 100px;
	background: $bg-red2;
	position: absolute;
}
</style>
